import React, {Suspense, lazy} from 'react';
import {BrowserRouter, Route, Redirect, Switch} from 'react-router-dom';

import './App.css';
import SignInPage from './auth/containers/SignInPageContainer';
import SignOutPage from './auth/containers/SignOutPageContainer';
import MainPage from './app/pages/MainPage';
import ResetPasswordPage from './passwordreset/containers/ResetPasswordContainer';
import navigationConfirmService from './shared/services/navigationConfirmService';

// Lazy-load the Timesheet Tower easter egg so its bundle AND its scoped Tailwind
// CSS ship as a separate chunk that only loads on /EasterEgg.
const EasterEggPage = lazy(() => import('./app/pages/EasterEggPage'));

// React Router fires getUserConfirmation when a <Prompt> is active and the
// user tries to navigate.  We route that through our service so the mounted
// UnsavedChangesGuard can show a styled in-app dialog instead of the default
// window.confirm() call.  Non-unsaved-changes prompts fall back to native.
const handleNavigationConfirm = (message, callback) => {
  if (message === '__unsaved__') {
    navigationConfirmService.trigger(callback);
  } else {
    callback(window.confirm(message));
  }
};

/**
 * Top level routes for the application.
 *
 * appPage is a decorator that includes a getCurrentUser query to pass the user info
 * (and check the login validity)
 * If they are not currently logged in, they will be immediately redirected to the login screen.
 */
export default () => (
  <BrowserRouter
    onUpdate={() => window.scrollTo(0, 0)}
    getUserConfirmation={handleNavigationConfirm}>
    <Switch>
      <Route path="/resetpassword/:resetToken" component={ResetPasswordPage} />
      <Route path="/login" component={SignInPage} />
      <Route path="/logout" component={SignOutPage} />
      <Route
        path="/EasterEgg"
        render={() => (
          <Suspense fallback={<div style={{minHeight: '100vh'}} />}>
            <EasterEggPage />
          </Suspense>
        )}
      />
      <Redirect from="/" exact to="/login" />
      <Route path="/" component={MainPage} />
    </Switch>
  </BrowserRouter>
);
